<template>
  <spinning-wheel-campaign-form :route="route"></spinning-wheel-campaign-form>
</template>

<script>
import SpinningWheelCampaignForm from './SpinningWheelCampaignForm.vue'

export default {
  components: { SpinningWheelCampaignForm },
  props: {
    route: { type: Object, default: () => ({}) }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/SpinningWheel/SpinningWheelCampaignAdd.vue